// Sidebar badge counts (design 3a: the count pills on Appointments and Team).
//
// The navbar renders on every dashboard screen, so it must not fetch for the
// badges itself — the pages that already load bookings or members publish what
// they found here, and the navbar subscribes. Counts are therefore "best known
// so far": absent until a page that owns that data has loaded once.

const store = { bookings: null, team: null };
const listeners = new Set();

export const PRO_NAV_COUNTS_EVENT = "haastia.pro.navCounts";

const toCount = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric >= 0 ? Math.round(numeric) : null;
};

export const getProNavCounts = () => ({ ...store });

export const publishProNavCounts = (counts) => {
  if (!counts || typeof counts !== "object") return;

  let changed = false;
  Object.keys(store).forEach((key) => {
    if (!(key in counts)) return;
    const next = toCount(counts[key]);
    if (store[key] !== next) {
      store[key] = next;
      changed = true;
    }
  });

  if (!changed) return;
  listeners.forEach((listener) => listener(getProNavCounts()));
};

export const subscribeProNavCounts = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Clearing on workspace switch stops one workspace's badges leaking into another.
export const resetProNavCounts = () => {
  publishProNavCounts({ bookings: null, team: null });
};
